export default "__VITE_PUBLIC_ASSET__b1acbd26__"